module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Acknowledgments"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Acknowledgments\n            ")])]), _c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', [_c('span', {
    staticClass: "lede"
  }, [_vm._v("When you are as big and tall as I am,")]), _vm._v(" it takes a large group to\n          lift me up to new heights, but these folks find a way to do it. ")]), _vm._v(" "), _c('p', [_vm._v("Rhonda Findley, you turn my memories into wonderful stories. Eugenie Uhl, you make me\n          want to lick every photograph of the dishes I make. Michelle Branson and the Gibbs Smith\n          family, you take my creations and bring them to life. Austin Faucheaux, Cabral Moses, and\n          Becky Hebert, the work you put in before I turn on a burner to cook is amazing. The Family\n          Crew of WYES-TV in New Orleans, I hope everyone who watches can see just how good you all\n          are through the details, sounds, images, editing, and production. The relatives and\n          friends who help me keep the facts and stories accurate. Deb Goldfarb and Elton Jones, who\n          help me climb the mountain. My city of New Orleans, after 300 years you are still unique\n          because of the people and the culture. Monica, my best friend, my heart and soul, my\n          resource of inspiration, and my wife, you put up with me every day and I appreciate it\n          more than you can imagine. I am blessed. ")]), _vm._v(" "), _c('p', [_vm._v("Thanks to all of you who send kind words and thoughts. I hope I bring a little fun into\n          your day, and a smile. ")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("Kevin Belton")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', [_c('span', {
    staticClass: "lede"
  }, [_vm._v("New Orleans cooking is all about the trinity.")]), _vm._v(" It’s a magical\n          threesome that yields the flavor profile of authentic New Orleans cooking. So it’s only\n          fitting that I thank Chef Kevin Belton for the honor of working with him on this third\n          book in the series. It’s a window into who Kevin is as a chef, a true native with a deep\n          love and sense of connection to the cuisine and culture of this gem we call New Orleans.\n          He is such a tremendous culinary ambassador for Louisiana. Chef Kevin, New Orleans is\n          lucky to have you as a native son, and I am forever grateful to you. ")]), _vm._v(" "), _c('p', [_vm._v("To New Orleans: for giving me a sense of place and a community of like-minded neighbors\n          who relate so specifically to the food, culture, and history of this beloved city. ")]), _vm._v(" "), _c('p', [_vm._v("To Carlos: for volunteering countless hours to the mission of bringing locally grown\n          produce to our community, and for making the greatest cup of New Orleans’ coffee everyday\n          along with other wonderful flavors at our family table. What an inspiration! ")]), _vm._v(" "), _c('p', [_vm._v("And, of course, to all of the strong women in my life: just as Chef Kevin inspires us to\n          turn to our mothers and grandmothers for insight and inspiration, I, too, look to many\n          strong, smart women who make life a joy and learning experience every day. Emma Weber,\n          Twila Pearce Findley, Betty Findley, Sharon Dillard, Deborah Stewart, Karrie Wroten, Fatma\n          Aydin, Ruyevda Collins, Sona Aydin, Elif Taskin, Ayse Aydin, Amanda Zuniga, Terry Gordin,\n          Monica Pazmino, Ashley Schulte, Lynda Barnes, Lisa Suarez, Grace Wilson, and Kristin G.\n          Palmer, thank you for the inspiration. ")]), _vm._v(" "), _c('p', [_vm._v("And to all New Orleanians and Louisiana residents who keep it real everyday by making\n          family recipes and keeping tradition alive. "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Merci beaucoup mes amis. ")])]), _vm._v("I am proud to call New Orleans home. ")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("Rhonda K. Findley ")])]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Collage of New Orleans scenes."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Collage of New Orleans scenes.",
      "src": "images/page2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Lower middle left photo © Monica Pazmino")])])])])]), _c('a', {
    attrs: {
      "id": "d0e65",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0